import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import logo from "../images/logoDark.png";
import { useWindowDimensions } from "../contexts/WindowDimension";
import Dock from "react-dock";

function NavigationBar(props) {
    const {hideLogin, hidePricing} = props
    const {currentUser} = useAuth();
    const {width, height} = useWindowDimensions();
    const isMobile = width <= 1220;
    const [isVisible, setIsVisible] = React.useState(false);

    const getNavigationBarLinks = (user) => {
      if(user!=null){
        return(<React.Fragment>
          <li>
          <Link to="/dashboard" style={{ textDecoration: 'none', color:"black" }} >
              <span className="menu-options-title">Dashboard</span>
            </Link>
          </li>
          <li>
          <Link to="/cards" style={{ textDecoration: 'none', color:"black" }} >
              <span className="menu-options-title">Payments</span>
            </Link>
          </li>
          <li>
            <Link to="/signout" style={{ textDecoration: 'none', color:"black" }}>
              <span className="menu-options-title">Logout</span>
            </Link>
          </li>
        </React.Fragment>);
      }else{
        return(<React.Fragment>
          <li>
          <Link to="/dashboard" style={{ textDecoration: 'none', color:"black" }} >
              <span className="menu-options-title">Dashboard</span>
            </Link>
          </li>
          {
            hidePricing
            ? ""
            :
              <li>
                <Link to="/prices" style={{ textDecoration: 'none', color:"black" }} >
                  <span className="menu-options-title">Pricing</span>
                </Link>
              </li>
          }
          
          {
            hideLogin ? 
            ""
            :
            <li>
              <Link to="/login">
                <span className="menu-options-title">Get access</span>
              </Link>
            </li>
          }
          
        </React.Fragment>);
      }
    }

    if(!isMobile) {
      return (
          <div className="top-bar-wrappper" id="front-page-top-bar">
          <div className="website-title" >
            <Link to="/">
              <img src={logo}  style={{width:"86px"}}/>
            </Link>
          </div>
          <ul className="top-bar-links">
            {getNavigationBarLinks(currentUser)}
          </ul>
        </div>
      )
    } else {
      return (
        <div className="top-bar-wrappper" id="front-page-top-bar">
          <div className="website-title" >
            <Link to="/">
              <img src={logo} style={{width:"86px"}}/>
            </Link>
          </div>
          <span className="menu-button" 
            style={{color:"black", cursor:"pointer"}} 
            onClick={()=>setIsVisible(true)}>
              <i className="fa fa-bars"></i>
          </span>
          <Dock 
            position="right"
            fluid={true}
            isVisible={isVisible}
            size={1}
            dimStyle={{ background: "rgba(0, 0, 0, 0.7)" }}
            dockStyle={{ background: "rgba(255, 255, 255, 0.9)" }}>
            <span className="menu-button" 
              style={{color:"black", cursor:"pointer"}} 
              onClick={()=>setIsVisible(false)}>
                <i className="fa fa-times"></i>
            </span>
            <ul className="side-navbar-links">
              {getNavigationBarLinks(currentUser)}
            </ul>
            
          </Dock>
        </div>
        
      )
    }
}

NavigationBar.propTypes = {

}

export default NavigationBar
